(function () {
  function updateQueryParam(key, value) {
    var url = new URL(window.location.href);
    if (value === null || value === undefined || value === '') {
      url.searchParams.delete(key);
    } else {
      url.searchParams.set(key, value);
    }
    // reset to first page when changing view
    url.searchParams.delete('page');
    window.location = url.toString();
  }

  document.addEventListener('DOMContentLoaded', function () {
    var select = document.getElementById('CollectionViewSelect');
    if (select) {
      select.addEventListener('change', function (e) {
        var v = e.target.value;
        updateQueryParam('view', v);
      });
    }

    var loadMoreBtn = document.getElementById('CollectionLoadMore');
    var productGrid = document.getElementById('product-grid');
    if (!productGrid) return;

    var totalPages = parseInt(productGrid.getAttribute('data-total-pages') || '1', 10);
    var currentPage = parseInt(productGrid.getAttribute('data-current-page') || '1', 10);
    var view = productGrid.getAttribute('data-view') || '';

    if (view !== 'all') return; // only add load-more/infinite for 'all' view

    var loading = false;
    var observer = null;

    function fetchPage(page) {
      if (loading) return Promise.reject('loading');
      loading = true;
      var url = new URL(window.location.href);
      url.searchParams.set('view', 'all');
      url.searchParams.set('page', page);
      return fetch(url.toString(), { credentials: 'same-origin' })
        .then(function (resp) { return resp.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('product-grid');
          if (!newGrid) return;
          var items = newGrid.querySelectorAll('li.grid__item');
          // append items
          items.forEach(function (it) {
            productGrid.appendChild(it);
          });
          currentPage = page;
          productGrid.setAttribute('data-current-page', String(currentPage));
          if (currentPage >= totalPages) {
            removeLoadMore();
          } else if (loadMoreBtn) {
            loadMoreBtn.setAttribute('data-next-page', String(currentPage + 1));
          }
        })
        .catch(function (err) {
          console.error('Error loading more products', err);
        })
        .finally(function () { loading = false; });
    }

    function removeLoadMore() {
      if (observer) { observer.disconnect(); observer = null; }
      if (loadMoreBtn && loadMoreBtn.parentNode) { loadMoreBtn.parentNode.removeChild(loadMoreBtn); }
    }

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var next = parseInt(loadMoreBtn.getAttribute('data-next-page') || (currentPage + 1), 10);
        fetchPage(next).then(function () {
          // after user clicks once, enable infinite scroll
          enableInfiniteScroll();
        });
      });

      function enableInfiniteScroll() {
        if ('IntersectionObserver' in window && !observer) {
          observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting && !loading) {
                var next = parseInt(loadMoreBtn.getAttribute('data-next-page') || (currentPage + 1), 10);
                if (next <= totalPages) {
                  fetchPage(next);
                } else {
                  removeLoadMore();
                }
              }
            });
          }, { rootMargin: '400px' });
          observer.observe(loadMoreBtn);
        }
      }
    }
  });
})();
